
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/category/[slug]/page/[page]",
      function () {
        return require("private-next-pages/components/category/[slug]/page/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/category/[slug]/page/[page]"])
      });
    }
  